<script>
    import {network} from "../../stores";

    export let onfile = () => {};

    let progres = false

    const onFileSelect = async (e) => {

        let files = e.target.files;
        let links = [];

        for (let i = 0; i < files.length; i++) {
            progres = true;
            let file = files[i]
            let buffer = await file.arrayBuffer()

            let result = await network.upload_file({buffer, name: file.name})

            if (result.length) {
                links.push(result[0]?.url_direct ?? '')
            }
            progres = false
        }

        if (links.length) {
            onfile(links.filter((i) => i.trim().length > 0).join(';'));
        }
    }
</script>

<div class="form-group boxed">
    <div class="input-wrapper">
        <div class="input-wrapper">
            <label class="form-label" for="file">Файл</label>
            <input type="file" class="form-control" id="file" accept="image/*" on:change={onFileSelect} multiple style="display: none">
            <label class="btn btn-outline-primary w-100" for="file">
                Выбрать файлы
                {#if progres}
                    <i class="fa fa-cog fa-spin ms-1"></i>
                {/if}
            </label>
        </div>
    </div>
</div>
